import React, { useState, useEffect, useMemo } from 'react';
import { pastel } from '../colorFromName';
import '../style/filters.css';

const FACET_DEFS = [
  { key: 'loc', icon: '📍', label: 'Lieu' },
  { key: 'year', icon: '📅', label: 'Année' },
  { key: 'by', icon: '📷', label: 'Photographe' },
];

function yearOf(photo) {
  const t = photo.exif && photo.exif.takenAt;
  if (!t) return null;
  const d = new Date(t);
  return Number.isNaN(d.getTime()) ? null : String(d.getFullYear());
}
function valueOf(photo, key) {
  if (key === 'loc') return photo.location || null;
  if (key === 'by') return photo.photographer || null;
  if (key === 'year') return yearOf(photo);
  return null;
}

function PhotoFilters({ photos, onFilter }) {
  const [open, setOpen] = useState(false);
  const [sel, setSel] = useState({ loc: [], year: [], by: [] });

  const facets = useMemo(() => FACET_DEFS.map((f) => {
    const vals = [...new Set(photos.map((p) => valueOf(p, f.key)).filter(Boolean))];
    if (f.key === 'year') vals.sort((a, b) => Number(b) - Number(a));
    else vals.sort((a, b) => a.localeCompare(b, 'fr'));
    return { ...f, vals };
  }).filter((f) => f.vals.length > 0), [photos]);

  // Applique le filtre à chaque changement de sélection (ou des photos).
  useEffect(() => {
    const matches = (p) => FACET_DEFS.every((f) => {
      const s = sel[f.key];
      return !s.length || s.includes(valueOf(p, f.key));
    });
    onFilter(photos.filter(matches));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos, sel]);

  const toggle = (key, v) => setSel((prev) => {
    const has = prev[key].includes(v);
    return { ...prev, [key]: has ? prev[key].filter((x) => x !== v) : [...prev[key], v] };
  });
  const clear = () => setSel({ loc: [], year: [], by: [] });

  const count = sel.loc.length + sel.year.length + sel.by.length;

  if (!facets.length) return null;

  return (
    <div className={`bb-filters ${open ? 'is-open' : ''}`}>
      <button type="button" className="bb-filters__toggle" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <span>🔎 Filtrer</span>
        {count > 0 && <span className="bb-filters__badge bb-meta">{count}</span>}
        <span className="bb-filters__chev" aria-hidden="true">▾</span>
      </button>

      {open && (
        <div className="bb-filters__body">
          {facets.map((f) => (
            <div className="bb-filters__row" key={f.key}>
              <span className="bb-filters__label">{f.icon} {f.label}</span>
              <div className="bb-filters__chips">
                {f.vals.map((v) => {
                  const on = sel[f.key].includes(v);
                  return (
                    <button
                      type="button"
                      key={v}
                      className={`bb-fchip${on ? ' is-on' : ''}`}
                      style={on ? { background: pastel(v) } : undefined}
                      onClick={() => toggle(f.key, v)}
                      aria-pressed={on}
                    >
                      {v}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
          {count > 0 && (
            <button type="button" className="bb-fchip bb-filters__reset" onClick={clear}>Tout effacer</button>
          )}
        </div>
      )}
    </div>
  );
}

export default PhotoFilters;
